import { render, staticRenderFns } from "./ContentMessage.vue?vue&type=template&id=afacfe0a&scoped=true&"
import script from "./ContentMessage.vue?vue&type=script&lang=js&"
export * from "./ContentMessage.vue?vue&type=script&lang=js&"
import style0 from "./ContentMessage.vue?vue&type=style&index=0&id=afacfe0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afacfe0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardTitle,VDivider,VList,VListItem,VListItemContent,VListItemTitle,VTooltip})
